import { JSONContent } from "@tiptap/react"
import { isPlaceholderImage } from "app/components/Editor/Image/constants"

import _ from "lodash"
import { fixImageNodeName } from "./tiptap"

// Remove base64 image placeholders
const removeImagePlaceholders = (json: JSONContent) => {
  const content: any = json.content?.filter((element: any) => {
    if (
      element &&
      element.type === "image" &&
      isPlaceholderImage(element.attrs.src)
    )
      return false
    if (
      element &&
      element.type === "figure" &&
      element.content[0].type === "image" &&
      isPlaceholderImage(element.content[0].attrs.src)
    )
      return false
    if (Array.isArray(element.content))
      return _.isEqual(removeImagePlaceholders(element), element.content)
    return true
  })
  return content
}

// Remove link embed placeholder
const removeLinkPlaceholders = (json: JSONContent) => {
  const content: any = json.content?.filter((element: any) => {
    if (element && element.type === "embedly" && !element.attrs.data)
      return false
    if (Array.isArray(element.content))
      return _.isEqual(removeLinkPlaceholders(element), element.content)
    return true
  })
  return content
}

// Remove Twitter embed placeholder
const removeTwitterPlaceholders = (json: JSONContent) => {
  const content: any = json.content?.filter((element: any) => {
    if (element && element.type === "twitter" && !element.attrs.tweetData)
      return false
    if (Array.isArray(element.content))
      return _.isEqual(removeTwitterPlaceholders(element), element.content)
    return true
  })
  return content
}

// Remove Sound.xyz embed placeholder
const removeSoundXyzPlaceholders = (json: JSONContent) => {
  const content: any = json.content?.filter((element: any) => {
    if (element && element.type === "soundXyz" && !element.attrs.embedId)
      return false
    if (Array.isArray(element.content))
      return _.isEqual(removeSoundXyzPlaceholders(element), element.content)
    return true
  })
  return content
}

const ignoreCommandListSlash = (json: JSONContent) => {
  const content: any = json.content?.filter((element: any) => {
    if (
      element &&
      element.type === "text" &&
      // https://regex101.com/r/224zLm/1
      /(^|\s)\/([^\s]*)$/gm.test(element.text)
    ) {
      console.log("cleanup, found command trigger", element.text)
      return false
    }
    if (Array.isArray(element.content))
      return _.isEqual(ignoreCommandListSlash(element), element.content)
    return true
  })
  return content
}

// Don't save Read More Gate modal changes
const ignoreReadMoreGateModalState = (json: JSONContent) => {
  const content: any = json.content?.map((element: any) => {
    if (element && element.type === "afterGate")
      return {
        ...element,
        attrs: { ...element.attrs, open: open === null ? null : false },
      }
    else if (Array.isArray(element.content))
      return ignoreReadMoreGateModalState(element)
    else return element
  })
  return { ...json, content }
}

// Don't save Empty State loading state changes
const ignoreEmptyStateState = (json: JSONContent) => {
  const content: any = json.content?.map((element: any) => {
    if (element && element.type === "emptyState")
      return {
        ...element,
        attrs: null,
      }
    else return element
  })
  return { ...json, content }
}

// Remove AskAi prompt
const removeAskAI = (json: JSONContent) => {
  const content: any = json.content?.filter((element: any) => {
    if (element && element.type === "askAi") return false
    else if (Array.isArray(element.content))
      return _.isEqual(removeAskAI(element), element.content)
    else return true
  })
  return content
}

const convertImageToFigure = (json: JSONContent) => {
  const content: any = json.content?.map((element: any) => {
    if (
      element &&
      element.type === "image" &&
      !isPlaceholderImage(element.attrs.src)
    )
      return {
        type: "figure",
        content: [element],
      }
    else if (Array.isArray(element.content) && element.type !== "figure")
      return convertImageToFigure(element)
    else return element
  })
  return { ...json, content }
}

export const cleanupJsonBeforeLoad = (json: JSONContent) => {
  let cleanJson = fixImageNodeName(json)
  cleanJson = convertImageToFigure(cleanJson)
  return cleanJson
}

export const cleanupJsonBeforeSave = (json: JSONContent) => {
  if (!_.isEqual(json.content, removeImagePlaceholders(json))) {
    console.log("Pending image embed. Skipping update...")
    return { json, skipSave: true }
  }
  if (!_.isEqual(json.content, removeLinkPlaceholders(json))) {
    console.log("Pending link embed. Skipping update...")
    return { json, skipSave: true }
  }
  if (!_.isEqual(json.content, removeTwitterPlaceholders(json))) {
    console.log("Pending Twitter embed. Skipping update...")
    return { json, skipSave: true }
  }
  if (!_.isEqual(json.content, removeSoundXyzPlaceholders(json))) {
    console.log("Pending Sound.xyz embed. Skipping update...")
    return { json, skipSave: true }
  }
  if (!_.isEqual(json.content, removeAskAI(json))) {
    console.log("AskAI prompt. Skipping update...")
    return { json, skipSave: true }
  }

  // Filter out specific state changes
  let cleanJson = ignoreEmptyStateState(json)
  cleanJson = ignoreReadMoreGateModalState(cleanJson)

  return { json: cleanJson, skipSave: false }
}

export function formatCoins(n: number) {
  return new Intl.NumberFormat("en").format(n)
}
